import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/AuthContext.js';
import '../styles/Login.css';
import logo from '../logo.png';

const Modal = ({ isOpen, onClose, title, message, type = 'error' }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className={`modal-header ${type}`}>
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          <button className="modal-btn" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
};

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, role, loading } = useAuth();
  const navigate = useNavigate();
  const [modal, setModal] = useState({
  isOpen: false,
  title: '',
  message: '',
  type: 'error'
});

const showModal = (title, message, type = 'error') => {
  setModal({
    isOpen: true,
    title,
    message,
    type
  });
};

const closeModal = () => {
  setModal({
    isOpen: false,
    title: '',
    message: '',
    type: 'error'
  });
};


  useEffect(() => {
    if (loading) return; // Wait until auth state is resolved
    if (role === 'employee') {
      navigate('/dashboard');
    } else if (role === 'admin') {
      navigate('/admin-dashboard');
    } else if (role === 'outsource') {
      navigate('/outsource-dashboard');
    }
  }, [role, navigate, loading]);

  if (loading) return null; // Don't render login form while checking auth state

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { success, role: userRole } = await login(email, password);

    if (success && userRole === 'employee') {
      navigate('/dashboard');
    } else if (success && userRole === 'admin') {
      navigate('/admin-dashboard');
    } else if (success && userRole === 'outsource') {
      navigate('/outsource-dashboard');
    } else {
      showModal('Login Failed', 'Invalid credentials. Please check your email and password.');
    }
  };

  return (
    <div className="login-page">
      <header className="login-header">
        <img src={logo} alt="Logo" className="login-logo" />
        <h2 className="welcome-text">Welcome to EMS Portal</h2>
      </header>

      <div className="login-card">
        <form onSubmit={handleSubmit} className="login-form">
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
            className="login-input"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
            className="login-input"
          />
          <button type="submit" className="login-button">Login</button>
        </form>
      </div>
      <Modal
        isOpen={modal.isOpen}
        onClose={closeModal}
        title={modal.title}
        message={modal.message}
        type={modal.type}
      />
    </div>
  );
};

export default Login;
